import _get from 'lodash/get';
import { Values } from '@lib/interfaces/form';
import { DepartmentCreateInputObject } from 'graphql-common';
import DepartmentFieldNames from '@lib/enums/fieldNames/departmentFieldNames';
import mergeAndUnlinkMultiSelectValues from '@lib/utils/mergeAndUnlinkMultiSelectValues';
import { SelectOption } from '@lib/components/Select/types';

const toLinks = (values: Values, fieldName: string) =>
  ((_get(values, fieldName) || []) as SelectOption[]).map(({ value }) => ({
    id: `${value}`,
  }));

export default function getDepartmentPreparedDataFromValues(
  values: Values,
  prevValues: Values = {},
) {
  return {
    name: _get(values, DepartmentFieldNames.Name),
    description: _get(values, DepartmentFieldNames.Description),
    color: _get(values, [DepartmentFieldNames.Color, 'value']),
    parentId:
      _get(values, [DepartmentFieldNames.ParentDepartment, 'value']) || null,
    managerId: _get(values, [DepartmentFieldNames.Manager, 'value']) || null,
    members: mergeAndUnlinkMultiSelectValues(
      toLinks(prevValues, DepartmentFieldNames.Members),
      toLinks(values, DepartmentFieldNames.Members),
    ),
    teamLinks: mergeAndUnlinkMultiSelectValues(
      toLinks(prevValues, DepartmentFieldNames.AccessGroups),
      toLinks(values, DepartmentFieldNames.AccessGroups),
    ),
    taskLinks: mergeAndUnlinkMultiSelectValues(
      toLinks(prevValues, DepartmentFieldNames.Tasks),
      toLinks(values, DepartmentFieldNames.Tasks),
    ),
    interventionLinks: mergeAndUnlinkMultiSelectValues(
      toLinks(prevValues, DepartmentFieldNames.Interventions),
      toLinks(values, DepartmentFieldNames.Interventions),
    ),
  } as DepartmentCreateInputObject;
}
